import React, { Component } from 'react';
import PropTypes from 'prop-types';

/**
 * @props {string} value - required
 * @props {Object} returnObj -required
 * @props {function} onChange - required
 */
class InputText extends Component {
	componentDidMount() {
		const { autoFocus } = this.props;
		if(autoFocus === true) {
			this.nameInput.focus();
		}
	}

	render() {	
		const { value, type, disabled } = this.props;
		return <input
			ref={(input) => { this.nameInput = input; }} 
			type={type}
			onChange = { this.onChange } 
			onKeyUp = { this.onChange }
			onBlur = { this.onBlur }
			maxLength = { this.returnPropIfExists('maxLength') }
			className = {this.className()}
			placeholder = { this.returnPropIfExists('placeholder') } 
			value = {value}
			disabled = { disabled }
		/>
	}

	className = () => {
		const { disabled, classNameAdd } = this.props;
		let baseClass = 'pt-input';
		if(disabled === true) {
			baseClass += ' pt-disabled';  
		}
		if(classNameAdd !== '') {
			baseClass += ' ' + classNameAdd
		}
		return baseClass;
	}

	onBlur = (event) => {
		const { onBlur, returnObj } = this.props;
		if(onBlur === null) {
			return null;
		}
		const value = event.target.value;
		return this.props.onBlur(this.validate(value), returnObj);
	}
	
	onChange = (event) => {
		const { returnObj } = this.props;
		const value = event.target.value;
		return this.props.onChange(this.validate(value), returnObj);
	}
		
	returnPropIfExists = (prop) => {
		if(this.props.hasOwnProperty(prop)) {
			return this.props[prop];
		}
		return null;
	}
	
	validate = (val) => {
		return val;
	}
		
	isOverMax = (val) => {
		const max = this.returnPropIfExists('max')
		if(max !== null) {
			if(val > max) {
				return max;
			}
		}
		return val;
	}
}

InputText.propTypes = {
	value: PropTypes.string.isRequired,
	returnObj: PropTypes.object.isRequired,
	onChange: PropTypes.func.isRequired,
	onBlur: PropTypes.func,
	type: PropTypes.string,
	max: PropTypes.number,
	autoFocus: PropTypes.bool,
	placeholder: PropTypes.string
}

InputText.defaultProps = {
	type: 'text',
	onBlur: null,
	classNameAdd: '',
	disabled: false
}

export default InputText;



// WEBPACK FOOTER //
// ./src/components/blueprintWrappers/InputText.js